import { memo, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useOverlayStore } from '../stores/useOverlayStore';
import { useLoadingStore } from '../stores/useLoadingStore';
import { useToast } from '../hooks/toast/useToast';
import { DELETE_MOTIVES } from '../utils/tripUtils';
import { useDeleteTripModalStore } from '../stores/useDeleteTripModalStore';
import { useSocketStore } from '../stores/useSocketStore';
import CustomSelect from './CustomSelect';

const DeleteTripModal = ({ trip, occurrence, onClose }) => {

    const { success, error } = useToast();

    const motive = useDeleteTripModalStore(state => state.motive);
    const setMotive = useDeleteTripModalStore(state => state.setMotive);

    const setCanClose = useOverlayStore(state => state.setCanClose);

    //CODIGO
    const codigo = trip.CODIGO_INTEGRACAO;

    //NOMELINHA
    const nomeLinha = trip.NOMELINHA;

    const setLoadingBackdrop = useLoadingStore(state => state.setLoadingBackdrop);
    const setLoadingTxt = useLoadingStore(state => state.setLoadingTxt);
    const loadingBackdrop = useLoadingStore(state => state.loadingBackdrop);

    const handleCloseModal = () => {

        onClose?.();
        useDeleteTripModalStore
            .getState()
            .clear();
    };

    const socket = useSocketStore(state => state.socket);

    const handleConfirm = () => {

        setLoadingBackdrop(true);
        setLoadingTxt('Removendo...');
        socket.emit(
            'trip:delete',
            {
                requestUid: crypto.randomUUID(),
                tripId: trip?.VIAGEM_ID,
                tripUid: trip?.TRIP_UID,
                motiveId: motive
            },
            (response) => {
                setLoadingBackdrop(false);
                setLoadingTxt('');
                if (!response?.ok) {
                    error(response?.message || 'Falha ao deletar a viagem.');
                    return;
                }

                success('Viagem removida com sucesso.');

                useOverlayStore
                    .getState()
                    .setCanClose(true);

                handleCloseModal();
            }
        );
        
    };

    useEffect(() => {
        setCanClose(!loadingBackdrop);
    }, [setCanClose, loadingBackdrop])

    return (
        <Box sx={{ minWidth: 680 }}>
            <Typography variant="h6" mb={0}>
                Deletar Viagem: {codigo}
            </Typography>
            <Typography variant="h6" mb={2}>
                {nomeLinha}
            </Typography>
            <CustomSelect
                items={DELETE_MOTIVES}
                selected={motive}
                onChange={(val) => setMotive(val)}
                label="Motivo"
                allowNone={false}
                enableSearch={true}
                scrollToSelected={true}
            />
            <Box mt={3} display="flex" justifyContent="space-between">            
                <Button disabled={loadingBackdrop} variant="contained" color='error' onClick={handleCloseModal}>Cancelar</Button>

                <Button
                    disabled={(loadingBackdrop || motive === 0)}
                    variant="contained"
                    color='success'
                        onClick={handleConfirm}
                    >
                    Confirmar
                </Button>
            </Box>
        </Box>
    );
};

export default memo(DeleteTripModal);